<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import numberMixin from '../../../../mixins/numberMixin';

export default {
  name: 'SkiRentalAvailableProducts',
  data() {
    return {
      selectedArea: undefined,
    };
  },
  mixins: [numberMixin],
  computed: {
    ...mapGetters({
      participants: 'booking/getParticipantsWithFullName',
      availableDates: 'booking/getAvailableDates',
      availableRentalProducts: 'skirental/getAvailableSkiRentalProducts',
      availableRentalProductsPersonCategoryHeaders: 'skirental/getAvailableSkiRentalProductsPersonCategoryHeaders',
      defaultAreaId: 'booking/getDefaultAreaId',
    }),
    ...mapState({
      participantsLoading: state => state.booking.participants.itemsLoading,
      participantsError: state => state.booking.participants.itemsError,
      selectedBookingParticipant: state => state.skirental.search.selectedBookingParticipant,
      selectedStartDate: state => state.skirental.search.selectedStartDate,
      selectedNumberOfDays: state => state.skirental.search.selectedNumberOfDays,
      selectedMultipleLevelTypes: state => state.skirental.search.selectedMultipleLevelTypes,
      selectedMultipleSkiTypes: state => state.skirental.search.selectedMultipleSkiTypes,
      bookingParticipants: state => state.skirental.bookingParticipants.items,
      levelTypes: state => state.skirental.levelTypes.items,
      skiTypes: state => state.skirental.skiTypes.items,
      rentals: state => state.skirental.rentals.items,
      rentalsLoading: state => state.skirental.rentals.itemsLoading,
      rentalsError: state => state.skirental.rentals.itemsError,
      availableRentalProductsLoading: state => state.skirental.availableRentalProducts.itemsLoading,
      availableRentalProductsError: state => state.skirental.availableRentalProducts.itemsError,
      availableRentalProductsSaveLoading:
        state => state.skirental.availableRentalProducts.saveLoading,
      availableRentalProductsSaveError: state => state.skirental.availableRentalProducts.saveError,
      booking: state => state.booking.booking,
      user: state => state.app.auth.user,
      availableNumberOfDays: state => state.skirental.search.availableNumberOfDays,
      areas: state => state.booking.areas.items,
    }),
    canSearch() {
      return this.booking.id
        && this.booking.stays
        && this.booking.stays.length
        && this.participants
        && this.participants.length
        && this.selectedBookingParticipant
        && this.selectedStartDate
        && this.selectedNumberOfDays
        && (this.selectedArea || this.defaultAreaId);
    },
    loading() {
      return this.participantsLoading
        || this.rentalsLoading
        || this.availableRentalProductsLoading
        || this.availableRentalProductsSaveLoading;
    },
    errorOccurred() {
      return this.rentalsError
        || this.availableRentalProductsError
        || this.participantsError
        || this.availableRentalProductsSaveError;
    },
  },
  methods: {
    ...mapActions({
      loadAvailableRentalProducts: 'skirental/availableRentalProductsLoad',
      loadRentalProductsByBookingId: 'skirental/rentalProductsByBookingIdLoad',
      createRentalProduct: 'skirental/rentalProductCreate',
      deleteRentalProduct: 'skirental/rentalProductDelete',
      setBookingParticipant: 'skirental/setBookingParticipant',
      setStartDate: 'skirental/setStartDate',
      setNumberOfDays: 'skirental/setNumberOfDays',
      setLevelTypes: 'skirental/setLevelTypes',
      setSkiTypes: 'skirental/setSkiTypes',
    }),
    createSkiRentalProduct(params) {
      const priceGross = params.price.priceGross;
      const priceNet = params.price.priceNet;
      let discountGross = null;
      let discountNet = null;
      let discountBookFrom = null;
      let discountBookTo = null;
      if (params.price.discount && params.price.discount.id) {
        const discountPercentage = params.price.discount.percentage / 100;
        discountGross = this.$options.filters.roundNumber(priceGross * discountPercentage, 0);
        discountNet = this.$options.filters.roundNumber(priceNet * discountPercentage, 0);
        discountBookFrom = params.price.discount.bookFrom;
        discountBookTo = params.price.discount.bookTo;
      }
      const personCategoryAges = ` (${params.price.personCategory.ageFrom}-${params.price.personCategory.ageTo} years)`;
      const skiRentalProduct = {
        areaId: this.selectedBookingParticipant.areaId,
        productsSkiRentalSeasonId: params.skiTypeAndPackage.season.id,
        productsSkiRentalSkiTypeId: params.skiTypeAndPackage.skiType.id,
        productsSkiRentalPackageId: params.skiTypeAndPackage.package.id,
        productsSkiRentalPersonCategoryId: params.price.personCategory.id,
        productsSkiRentalLevelId: params.level.id,
        status: 'initiated',
        salesType: 'booking',
        supplierRef: null,
        firstSkiDay: this.selectedStartDate,
        numberOfDays: params.price.priceDay.days,
        price: this.$options.filters.roundNumber(priceGross, 0),
        priceNet: this.$options.filters.roundNumber(priceNet, 0),
        currencyNet: params.skiTypeAndPackage.season.supplier.currency,
        supplierName: params.skiTypeAndPackage.season.supplier.name,
        name: params.price.name,
        seasonName: params.skiTypeAndPackage.season.name,
        skiTypeName: params.skiTypeAndPackage.skiType.name,
        packageName: params.skiTypeAndPackage.package.name,
        personCategoryName: params.price.personCategory.name + personCategoryAges,
        levelName: params.level.name,
        nameSupplier: params.price.externalName,
        seasonNameSupplier: params.skiTypeAndPackage.season.name,
        skiTypeNameSupplier: params.skiTypeAndPackage.skiType.identifier,
        packageNameSupplier: params.skiTypeAndPackage.package.identifier,
        personCategoryNameSupplier: params.price.personCategory.externalName + personCategoryAges,
        levelNameSupplier: params.level.identifier,
        discount: discountGross,
        discountNet,
        discountBookFrom,
        discountBookTo,
      };
      this.createRentalProduct({
        bookingId: this.booking.id,
        bookingParticipantId: this.selectedBookingParticipant.id,
        skiRentalProducts: [skiRentalProduct],
      });
    },
    deleteSkiRentalProduct(skiRentalProductId) {
      this.deleteRentalProduct({
        skiRentalProductId,
        salesAgentUserId: this.user.id,
      });
    },
    searchAvailableProducts() {
      if (!this.canSearch) {
        return;
      }
      const areaId = this.selectedArea || this.defaultAreaId;
      this.loadAvailableRentalProducts({
        areaId,
        numberOfDays: this.selectedNumberOfDays,
        participantAge: this.selectedBookingParticipant.age,
        skiStartDayDate: this.selectedStartDate,
        targetCurrency: this.booking.currency,
      });
    },
    doRefresh() {
      this.loadRentalProductsByBookingId(this.booking.id);
      this.searchAvailableProducts();
    },
    onBookingParticipantChange(participant) {
      this.setBookingParticipant(participant);
      this.searchAvailableProducts();
    },
    onStartDateChange(startDate) {
      this.setStartDate(startDate);
      this.searchAvailableProducts();
    },
    onNumberOfDaysChange(days) {
      this.setNumberOfDays(days);
      this.searchAvailableProducts();
    },
    onMultipleLevelTypesChange(levelTypeIds) {
      this.setLevelTypes(levelTypeIds);
    },
    onMultipleSkiTypeChange(skiTypeIds) {
      this.setSkiTypes(skiTypeIds);
    },
    onAreaChange(areaId) {
      this.selectedArea = areaId;
      this.searchAvailableProducts();
    },
  },
  mounted() {
    const arrivalDate = this.booking.stays[0].arrivalDate;
    const departureDate = this.booking.stays[0].departureDate;
    const numberOfDays = this.$moment(departureDate).diff(this.$moment(arrivalDate), 'days') + 1;
    this.setStartDate(arrivalDate);
    this.setNumberOfDays(numberOfDays);
  },
};
</script>

<template>
  <v-container v-if="booking && booking.id" class="pa-0 pt-3" grid-list-xl>
    <v-card
      class="pa-3 mx-auto"
      outlined
    >
      <v-layout class="pt-3 pl-3 pr-3">
        <v-flex class="ma-0 pa-0" sm5 xs12>
          <v-select
            @change="onBookingParticipantChange"
            :value="selectedBookingParticipant"
            :items="participants"
            :loading="participantsLoading"
            :disabled="participantsLoading || !participants.length"
            :label="$t('ski.rental.selects.booking-participant')"
            item-text="fullName"
            return-object
          />
        </v-flex>
        <v-flex class="pl-2 ma-0 pa-0" sm2 xs12>
          <v-select
            @change="onStartDateChange($event)"
            :value="selectedStartDate"
            :items="availableDates"
            :loading="participantsLoading"
            :disabled="participantsLoading"
            :label="$t('ski.rental.selects.start-date')"
            item-text="name"
            item-value="id"
          />
        </v-flex>
        <v-flex class="pl-2 ma-0 pa-0" sm2 xs12>
          <v-select
            @change="onNumberOfDaysChange($event)"
            :value="selectedNumberOfDays"
            :items="availableNumberOfDays"
            :loading="participantsLoading"
            :disabled="participantsLoading"
            :label="$t('ski.rental.selects.number-of-days')"
          />
        </v-flex>
        <v-flex v-if="areas.length > 1" class="pl-2 ma-0 pa-0" sm2 xs12>
          <v-select
            @change="onAreaChange($event)"
            :value="defaultAreaId || null"
            :items="areas"
            :label="$t('ski.rental.selects.area')"
            item-text="name"
            item-value="id"
          />
        </v-flex>
      </v-layout>
      <v-layout class="pl-3 pr-3">
        <v-flex class="ma-0 pa-0" sm5 xs12>
          <v-autocomplete
            @change="onMultipleLevelTypesChange($event)"
            :value="selectedMultipleLevelTypes"
            :items="levelTypes"
            :loading="loading"
            :disabled="!levelTypes.length"
            :deletable-chips="true"
            :label="$t('ski.rental.selects.multiple-level-types')"
            item-text="name"
            item-value="id"
            clearable
            chips
            multiple
          />
        </v-flex>
        <v-flex class="pl-2 ma-0 pa-0" sm5 xs12>
          <v-autocomplete
            @change="onMultipleSkiTypeChange($event)"
            :value="selectedMultipleSkiTypes"
            :items="skiTypes"
            :loading="loading"
            :disabled="!skiTypes.length"
            :deletable-chips="true"
            :label="$t('ski.rental.selects.multiple-ski-types')"
            item-text="name"
            item-value="id"
            clearable
            chips
            multiple
          />
        </v-flex>
        <v-flex class="pl-2 ma-0 pa-0" sm1 xs12>
          <v-btn
            @click="doRefresh()"
            :loading="loading"
            icon
          >
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <div class="text-center pa-1">
      <v-progress-linear v-show="loading" :indeterminate="true"/>
    </div>
    <v-alert
      :value="this.errorOccurred"
      color="error"
      icon="warning"
      outline
    >
      <span v-html="errorOccurred"></span>
    </v-alert>
    <div
      v-if="!Object.keys(availableRentalProducts).length && canSearch && !loading"
      class="pt-3 pb-3 font-weight-bold"
    >
      {{ $t('ski.rental.no-available-rental-products') }}
    </div>
    <v-container v-if="Object.keys(availableRentalProducts).length > 0" grid-list-md xs12>
      <div
        v-for="(skiTypeAndPackage) in availableRentalProducts"
        :key="skiTypeAndPackage.skiType.id + '-' + skiTypeAndPackage.package.id"
        class="pt-3 pb-3 font-weight-bold"
      >
        <v-layout class="pb-0 mb-0 no-wrap" row>
          <v-flex sm4 xs12>
            <h2>
              {{ skiTypeAndPackage.skiType.name }}
              <span class="font-weight-regular">({{ skiTypeAndPackage.package.name }})</span>
            </h2>
          </v-flex>
          <v-flex class="d-flex pt-3" sm8 xs12>
            <v-flex
              v-for="personCategory in availableRentalProductsPersonCategoryHeaders"
              :key="personCategory.id"
              class="ma-0 pa-0 ml-auto text-uppercase"
              xs12
            >
              {{ personCategory.name }}
              ({{ $t('ski.rental.years-from-to', {
                from: personCategory.ageFrom,
                to: personCategory.ageTo
              }) }})
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout
          v-for="(level) in skiTypeAndPackage.levels"
          :key="level.id"
          class="pb-0"
          row
        >
          <v-flex class="text-xs-right pt-3 pr-3" sm4 xs12>
            {{ level.name }}
          </v-flex>
          <v-flex class="ma-0 pa-0 d-flex" sm6 xs12>
            <v-flex
              v-for="(price) in level.prices"
              :key="price.id"
              class="ma-0 pa-0 ml-auto"
              xs12
            >
              <v-chip
                v-if="price.hasDiscount && price.discount"
                :title="$t('ski.rental.discount-percentage')"
                color="red"
                text-color="white"
                class="caption"
                disabled
                small
              >
                -{{ price.discount.percentage }}%
              </v-chip>
              <v-btn
                v-if="price.id && !price.bookingRentalProductId"
                @click="createSkiRentalProduct({ skiTypeAndPackage, level, price })"
                :disabled="loading"
                :loading="loading"
                :title="$t('ski.rental.add-product')"
                outline
              >
                <template v-if="price.hasDiscount">
                  {{ price.totalGrossAfterDiscount }} {{ booking.currency }}
                  <span class="text-line-through pl-2 red--text caption">
                    {{ price.priceDay.priceGross }} {{ booking.currency }}
                  </span>
                </template>
                <template v-else>
                  {{ price.priceDay.priceGross }} {{ booking.currency }}
                </template>
              </v-btn>
              <v-btn
                v-if="price.id && price.bookingRentalProductId"
                @click="deleteSkiRentalProduct(price.bookingRentalProductId)"
                :disabled="loading"
                :loading="loading"
                :title="$t('ski.rental.remove-product')"
                color="success"
              >
                {{ price.totalGrossAfterDiscount }} {{ booking.currency }}
                <v-icon right>cancel</v-icon>
              </v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
    </v-container>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/booking/ski/rental/SkiRentalAvailableProducts.vue